import { useSelector } from "react-redux";
import { SBAComboBox } from "../UiComponents/SBADropDown"
import { useState,useEffect } from "react";
import { sbaAxios } from "../utils/sbaAxios";
import { AgGridReact } from "ag-grid-react";
import { getUsersByTaxEntityAccess, getUsersByTenant, upsertUserTaxEntityAccess } from "../../config/apiConfig";
import { SBNotify } from "../utils/sbNotify";

export const TaxEntityToUser = () => {
    const Gstate = useSelector(state => state) || {};
    const [selectedTenant, setSelectedTenant] = useState({});
    const [userGridData, setuserGridData] = useState([]);
    const [taxEntityAccessList, setTaxEntityAccessList] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedTaxEntityIds, setSelectedTaxEntityIds] = useState("");
    const [isAllChecked, setIsAllChecked] = useState(false);
    const tenantsData = Gstate?.AdminPermissions?.TenantData || [];

    useEffect(() => { setSelectedTenant(tenantsData[0]) }, []);
    useEffect(() => { fetchUsersByTenant(true) }, [selectedTenant]);


    const tenantDDChange = (e) => {
        setSelectedTenant(e.value);
    };

    const fetchUsersByTenant = async(fromUseEffect) => {
        try{
            if(selectedTenant.TenantId)
            {
                const list = await sbaAxios({
                    url: `${getUsersByTenant}${selectedTenant.TenantId}`
                });
                const sortedList = list.sort((a, b) => a.UserName.localeCompare(b.UserName));
                setuserGridData(sortedList);
                resetState();
                if(fromUseEffect){
                    setTaxEntityAccessList([]);
                }
            }
           
        }
        catch(e){
            setuserGridData([]);
            resetState();
            setTaxEntityAccessList([]);
            if(fromUseEffect){
                setTaxEntityAccessList([]);
            }
        }
    };

    const fetchTaxEntityAccessByUsers = async(id) => {
        try{
            const list = await sbaAxios({
                url:`${getUsersByTaxEntityAccess}/${selectedTenant.TenantId}/${id}`
            });
            const sortedList = list.sort((a, b) => a.TaxEntityName.localeCompare(b.TaxEntityName));
            setTaxEntityAccessList(sortedList);
            const selectedIds = sortedList
            .filter((item) => item.RestrictedAccess === true) // Get only checked items
            .map((item) => item.TaxEntityId) // Extract TaxEntityIds
            .join(","); // Convert to comma-separated string

        setSelectedTaxEntityIds(selectedIds);
        }
        catch(e){
            setTaxEntityAccessList([]);
            setSelectedTaxEntityIds("");
        }
    };

    useEffect(() => {
        if(selectedUser){
            fetchTaxEntityAccessByUsers(selectedUser?.UserId)
        }
    }, [selectedUser]);

    useEffect(() => {
        console.log("selectedTaxEntitys: ", selectedTaxEntityIds);
    }, [selectedTaxEntityIds])

    const userGridDef = [
        {
            headerName: "User Name",
            field: "UserName"
        }
    ];
    const taxEntityAccessGridDef = [
        {
            headerName: "Account Name",
            field: "TaxEntityName",
            flex: 1
        },
        {
            headerName: "Restricted Access",
            field: "RestrictedAccess",
            flex: 1,
            cellRenderer: "agCheckboxCellRenderer",
            editable: true,
            cellClass: "cellCenter",
            headerClass: "headerCenter",
            headerComponent: CheckboxHeader,
            headerComponentParams: {
                setIsAllChecked, isAllChecked, setTaxEntityAccessList, setSelectedTaxEntityIds
            }
        },
    ];
    const defUserColDef = {
        flex: 1,
        filter: 'agTextColumnFilter' ,floatingFilter: true,resizable:true
    };

    const handleGridCheckbox = (params) => {
        if (params.column.colId === "RestrictedAccess") {
            const updatedList = taxEntityAccessList.map((item) =>
                item.TaxEntityId === params.data.TaxEntityId
                    ? { ...item, RestrictedAccess: params.newValue }
                    : item
            );
            setTaxEntityAccessList(updatedList);

            setSelectedTaxEntityIds(() => {
                let selectedIds = updatedList
                    .filter((p) => p.RestrictedAccess) // Get checked items
                    .map((p) => p.TaxEntityId) // Extract TaxEntityIds
                    .join(","); // Convert to comma-separated string
                return selectedIds;
            });
            // Update header checkbox based on whether all checkboxes are checked
        setIsAllChecked(updatedList.every((item) => item.RestrictedAccess));
        }     
    };
    
    const updateUserPageAcess = async() => {
        const saveData = {
            "UserId": selectedUser?.UserId,
            "TenantId": selectedTenant.TenantId,
            "RestrictedTaxEntities": selectedTaxEntityIds
        };
        await sbaAxios({ url: `${upsertUserTaxEntityAccess}`, method: 'post', data: saveData }).then(response => {
            SBNotify({ Msg: "TaxEntity Restriction Updated Successfully" });
           
        }).catch(e => {
            console.log(e);
        });
        fetchUsersByTenant(false);
        fetchTaxEntityAccessByUsers(selectedUser?.UserId);

    };

    const resetState = () => {
        setSelectedTaxEntityIds("");
    };

    return (
        <>
            <div className="col-lg-4 mt-4">
                <label
                    className="ms-2 fw-semibold fs-12"
                >
                    Select Tenant
                </label>
                <SBAComboBox data={tenantsData} textField={'TenantName'} valueField={'TenantId'} value={selectedTenant} onChange={tenantDDChange} />
            </div>

            <div className="d-flex gap-3 mt-2 justify-content-end">
                <button className="p-sm-btn" disabled={taxEntityAccessList.length === 0} onClick={() => { updateUserPageAcess() }}>Update</button>
            </div>
            
            <div className="row">
                <div className="col-6">
                    <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
                        <AgGridReact
                            columnDefs={userGridDef}
                            rowData={userGridData}
                            defaultColDef={defUserColDef}
                            pagination={true}
                            paginationPageSize={20}
                            onRowClicked={(params) => {
                                setSelectedUser(params?.data);
                                setSelectedTaxEntityIds("");
                                params.node.setSelected(true)
                            }}
                            rowSelection="Single"
                            getRowStyle={(params) => {
                                return params.data?.UserId === selectedUser?.UserId
                                    ? { background: "#d3f9d8" } 
                                    : {}; 
                            }}
                            suppressScrollOnNewData={true}
                        />
                    </div>
                </div>
                <div className="col-6">
                    <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
                        <AgGridReact
                            columnDefs={taxEntityAccessGridDef}
                            rowData={taxEntityAccessList}
                            defaultColDef={{
                                flex: 1,resizable:true
                            }}
                            rowSelection="Single"
                            onCellValueChanged={(params) => {handleGridCheckbox(params)}}
                            suppressScrollOnNewData={true}
                        />
                    </div>
                </div>
            </div>
        </>
    )
};


const CheckboxHeader = (props) => {
    const { setIsAllChecked, isAllChecked, setTaxEntityAccessList, setSelectedTaxEntityIds } = props;

    const toggleCheckAll = () => {
        setTaxEntityAccessList((prevList) => {
            const newCheckedState = !isAllChecked; // Toggle state

            const updatedList = prevList.map((item) => ({
                ...item,
                RestrictedAccess: newCheckedState, // Apply the new checked state to all
            }));

            const selectedIds = newCheckedState
                ? updatedList.map((item) => item.TaxEntityId).join(",") // All selected
                : ""; // None selected

            setSelectedTaxEntityIds(selectedIds);
            setIsAllChecked(newCheckedState); // Update the header checkbox state

            return updatedList;
        });
    };

    return (
        <div style={{ display: "flex", flexDirection: 'column', alignItems: "center", justifyContent: "center", width: "100%", color: "#545454", fontWeight: 600, gap: 10 }}>
            <span>Restricted Access</span>
            <input type="checkbox" checked={isAllChecked} onChange={toggleCheckAll} />
        </div>
    );
};
